module.exports = __webpack_public_path__ + "img/ico_fcu_5.6feccf71.png";